// extracted by mini-css-extract-plugin
export var component = "Link-module--component--AwBbM";
export var current = "Link-module--current--y5URn";
export var icon = "Link-module--icon--d-7AX";
export var inert = "Link-module--inert--d9kCl";
export var label = "Link-module--label--w1rOh";